import { getTenantRuntime } from '../../config/tenant';
import { useCellFeatures } from '../../contexts/CellFeaturesContext';
import { houseLabel, siteLabel } from '../../config/tenant';

export function HouseChip({ code }: { code?: string | null }) {
  const features = useCellFeatures();
  const property = getTenantRuntime().properties.find(item => item.key === code);
  return <span title={code ? siteLabel(code, features) : houseLabel(code)}
    style={property ? { borderLeftColor: `var(--${property.color})` } : undefined}
    className="inline-flex rounded-cell border border-line border-l-[3px] bg-panel px-1.5 py-0.5 font-mono text-[11px] font-semibold text-ink">
    {property?.label ?? houseLabel(code)}
  </span>;
}
